import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import themes from '../../theming/themes.js';
import React from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import { NavLink } from 'react-router-dom';
import SideNavLinkContainer from './SideNavLinkContainer.js';

var _templateObject;
var StyledNavLink = styled__default(NavLink)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  padding: 0.25rem 0 0.25rem 0.5rem;\n  &.active {\n    color: ", ";\n    font-weight: 500;\n    border-left: 3px solid ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.primary;
});
var SideNavLink = function SideNavLink(_ref4) {
  var active = _ref4.active,
    children = _ref4.children,
    _ref4$exact = _ref4.exact,
    exact = _ref4$exact === void 0 ? false : _ref4$exact,
    href = _ref4.href,
    index = _ref4.index,
    _ref4$onClick = _ref4.onClick,
    _onClick = _ref4$onClick === void 0 ? function () {} : _ref4$onClick,
    _ref4$theme = _ref4.theme,
    theme = _ref4$theme === void 0 ? themes["default"] : _ref4$theme,
    title = _ref4.title;
  return /*#__PURE__*/React.createElement(SideNavLinkContainer, null, /*#__PURE__*/React.createElement(StyledNavLink, {
    active: active,
    "data-testid": "sidenav-link",
    exact: exact,
    href: href,
    key: index,
    onClick: function onClick(e) {
      return _onClick(e);
    },
    theme: theme,
    title: title,
    to: title
  }, children));
};
var _SideNavLink = withDefaultTheme(SideNavLink);

export default _SideNavLink;
